export function formatDateTime(date, time, formatDate = 'y-m-d', withSeconds = false) {
    let day = time.getDate();
    let month = time.getMonth() + 1;
    let year = time.getFullYear();
    if(typeof date === 'string'){
        [day, month, year] = date.split('.');
    } else if(date instanceof Date && !isNaN(date)){
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();
    }
    let hours = time.getHours();
    let minutes = time.getMinutes();

    let dateTime = new Date(year, month - 1, day, hours, minutes, 0);

    let formattedYear = dateTime.getFullYear();
    let formattedMonth = String(dateTime.getMonth() + 1).padStart(2, '0');
    let formattedDay = String(dateTime.getDate()).padStart(2, '0');
    let formattedHours = String(dateTime.getHours()).padStart(2, '0');
    let formattedMinutes = String(dateTime.getMinutes()).padStart(2, '0');
    let formattedSeconds = String(dateTime.getSeconds()).padStart(2, '0');

    if(formatDate === 'd.m.y') {
        if(withSeconds) {
            return `${formattedDay}.${formattedMonth}.${formattedYear} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
        } else {
            return `${formattedDay}.${formattedMonth}.${formattedYear} ${formattedHours}:${formattedMinutes}`;
        }
    } else {
        if(withSeconds) {
            return `${formattedYear}-${formattedMonth}-${formattedDay} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
        } else {
            return `${formattedYear}-${formattedMonth}-${formattedDay} ${formattedHours}:${formattedMinutes}`;
        }
    }
}
